import { render, staticRenderFns } from "./IconSvgClock.vue?vue&type=template&id=4e150caa&scoped=true&"
import script from "./IconSvgClock.vue?vue&type=script&lang=js&"
export * from "./IconSvgClock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e150caa",
  null
  
)

export default component.exports